import React from 'react';
import Translate from 'react-translate-component';

import { notEmpty } from 'utils/ramdaAdditions';
import { getValidLink } from 'helpers/fieldsHelpers';

export const CompanyWebPages = ({ webs }) => notEmpty(webs) ? (
    <dl className='dl-horizontal'>
        <Translate
            content='company.webpage'
            component='dt'
            className='vertical-align-top'
        />
        <dd className='company-web-wrap'>
            { webs.split(/\n/).map((web, index) => (
                <div key={index}>
                    <a href={getValidLink(web)} target='_blank' rel="noopener noreferrer">
                        {web}
                    </a>
                </div>
            ))}
        </dd>
    </dl>
) : null;
